import React from "react";
import { Modal, modalStyles } from '@futures-platform/ui'
import { requestTranslation } from '@futures-platform/i18n'

const DeleteConfirmationModal = ({
  deletePublicLink,
  deleteConfirmationModal,
  deleteConfirmationModalClose,
}) => {
  return (
    <Modal
      isOpen={deleteConfirmationModal}
      contentLabel="radar-modal"
      ariaHideApp={false}
      onRequestClose={deleteConfirmationModalClose}
      // style={paddingModalStyles}
      style={{ content: { ...modalStyles.content, padding: '50px 0' }, overlay: { ...modalStyles.overlay, zIndex: 11111 } }}

    >
      <div className="confirmation-modal-content pt-4 pb-4">
        <h3 className="confirmation-modal-title">
          {requestTranslation("deletePublicLinkConfirmation")}
        </h3>
        <p style={{textAlign: 'center', marginLeft: '110px', marginRight: '117px'}}>{requestTranslation("deletePublicLinkConfirmationNote")}</p>
        <div className="confirmation-modal-actions">
          <button
            onClick={deleteConfirmationModalClose}
            className="btn btn-lg btn-plain-gray"
          >
            {requestTranslation("cancel").toUpperCase()}
          </button>
          <button
            className="btn btn-lg btn-primary"
            onClick={deletePublicLink}
          >
            {requestTranslation("deletePublicLink").toUpperCase()}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
